import { useEffect, useState } from "react";
import DataTable from "../../utils/DataTable";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import * as qs from "qs";

export default function ManageStudents({ title }) {
  const [activePanel, setActivePanel] = useState("students"); 
  const [studentsData, setStudentsData] = useState([]);
  const [batchStudentsData, setBatchStudentsData] = useState([]);
  const [status, setStatus] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // Search input state

  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);

  const userId = sessionStorage.getItem("userId");
  const userRole = sessionStorage.getItem("userRole");

  const fetchStudents = async () => {
    dispatch(showLoader());
    let reqData = {};
    if (userRole == 2) reqData.addedById = userId;
    reqData.status = status == 1 ? true : false;

    try {
      const res = await ApiServices.apiRequest("getStudent", qs.stringify(reqData));
      if (res.data.success) setStudentsData(res.data.data);
      else toast.error(res.data.message);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      dispatch(hideLoader());
    }
  };

  const fetchBatchStudents = async () => {
    dispatch(showLoader());
    try {
      const role = sessionStorage.getItem("userRole");
      const userId = sessionStorage.getItem("userId");

      // Add trainerId filter only if role == 2
      const payload =
        role == 2
          ? { trainerId: userId, status: true }
          : { status: true };

      const res = await ApiServices.apiRequest("getBatch", payload);

      if (res.data.success) {
        const batches = res.data.data;

        // 🔹 Flatten all students from all batches
        const allBatchStudents = batches.flatMap((batch) =>
          batch.studentsId?.map((student) => ({
            ...student,
            batchName: batch.name,
            batchTime: batch.batchTime,
            ownerName: batch.ownerId?.name,
          })) || []
        );

        setBatchStudentsData(allBatchStudents);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.message);
    } finally {
      dispatch(hideLoader());
    }
  };

  //Load data dynamically based on active panel
  useEffect(() => {
    if (isOpen === false) {
      if (activePanel === "students") fetchStudents();
      else if (activePanel === "batchStudents") fetchBatchStudents();
    }
  }, [activePanel, status, isOpen]);

  const filteredStudents =
  activePanel === "students"
    ? studentsData.filter((student) => {
        const term = searchTerm.toLowerCase();

        return (
          student.name?.toLowerCase().includes(term) ||
          student.email?.toLowerCase().includes(term) ||
          student.batchesId?.some((batch) =>
            batch?.name?.toLowerCase().includes(term)
          )
        );
      })
    : batchStudentsData.filter((student) => {
        const term = searchTerm.toLowerCase();

        return (
          student.name?.toLowerCase().includes(term) ||
          student.email?.toLowerCase().includes(term) ||
          student.batchName?.toLowerCase().includes(term)
        );
      });


  // const studentColumns = [
  //   { fields: "name", headerName: "Student Name" },
  //   { fields: "email", headerName: "Email" },
  //   { fields: "contact", headerName: "Contact" },
  //   // { fields: "address", headerName: "Address" },
  //   // { fields: "parentcontact", headerName: "Parent's Contact" },
  //   { fields: "batchesId", headerName: "No.Batch" },
  //   { fields: "college", headerName: "College" },
  //   { fields: "course", headerName: "Course" },
  //   { fields: "createdAt", headerName: "Joining" },
  // ];
  let  studentColumns
  if(sessionStorage.getItem("userRole")==2){
      studentColumns = [
    { fields: "name", headerName: "Student Name" },
    { fields: "email", headerName: "Email" },
    { fields: "contact", headerName: "Contact" },
    // { fields: "address", headerName: "Address" },
    // { fields: "parentcontact", headerName: "Parent's Contact" },
    // { fields: "batchesId", headerName: "No.Batch" },
    { fields: "college", headerName: "College" },
    { fields: "course", headerName: "Course" },
    { fields: "createdAt", headerName: "Joining" },
  ];
  }
  else{
      studentColumns = [
    { fields: "name", headerName: "Student Name" },
    { fields: "email", headerName: "Email" },
    { fields: "contact", headerName: "Contact" },
    // { fields: "address", headerName: "Address" },
    // { fields: "parentcontact", headerName: "Parent's Contact" },
    { fields: "batchesId", headerName: "No.Batch" },
    { fields: "college", headerName: "College" },
    { fields: "course", headerName: "Course" },
    { fields: "createdAt", headerName: "Joining" },
  ];
  }

  const batchStudentColumns = [
    { fields: "name", headerName: "Student Name" },
    { fields: "email", headerName: "Email" },
    { fields: "batchName", headerName: "Batch Name" },
    { fields: "batchTime", headerName: "Batch Time" },
    { fields: "ownerName", headerName: "Assigned By" },
  ];

  return (
    <div className="container">
      <div className="page-inner">
        {loading && !isOpen ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex justify-content-start mb-3">
              <button
                className={`btn me-2 ${activePanel === "students" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActivePanel("students")}
              >
                Added Students
              </button>
              {/* <button
                className={`btn ${activePanel === "batchStudents" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActivePanel("batchStudents")}
              >
                Assigned Students
              </button> */}
            </div>

            {/* Common Header + Filters */}
            <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
              <div>
                <h3 className="fw-bold mb-3">{title}</h3>
                {activePanel === "students" && (
                  <select
                    className="form-select"
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                  >
                    <option value={1}>Active</option>
                    <option value={2}>In-Active</option>
                  </select>
                )}
              </div>

              {/* Search Bar */}
              <div className="ms-md-auto py-2 py-md-0 d-flex align-items-center">
                <input
                  type="text"
                  className="form-control me-2 w-100"
                  placeholder="Search by name or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ maxWidth: "250px" }}
                />
                {activePanel === "students" && (
                  <>
                    <a
                      href="#"
                      onClick={() => dispatch(showModal("BulkAddStudents"))}
                      className="btn btn-outline-dark btn-round me-2 w-100"
                    >
                      + Bulk Add
                    </a>
                    <button
                      onClick={() => dispatch(showModal("AddStudents"))}
                      className="btn btn-primary btn-round w-100"
                    >
                      Add Student
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Data Display */}
            {activePanel === "students" ? (
              <DataTable rows={filteredStudents} columns={studentColumns} status={status} showActions={true} />
            ) : (
              <DataTable rows={filteredStudents} columns={batchStudentColumns} showActions={false} />
            )}
          </>
        )}
      </div>
    </div>
  );
}
